module.exports = __webpack_public_path__ + "static/media/facebook-circle.6c69e529.svg";